<template>
    <app-data-table :fields="fields" :items="data">
        <template slot="index" slot-scope="{ item, row }">{{ row + 1 }}</template>

        <template slot="created_at" slot-scope="{ item }">{{ item.created_at | datetime }}</template>

        <template v-if="seeActions" slot="actions" slot-scope="{ item }">
            <b-button
                size="sm"
                variant="danger"
                title="Eliminar Novedad"
                @click="removeNovelty(item.id)"
            >
                <i class="fa fa-trash"></i>
            </b-button>
        </template>
    </app-data-table>
</template>
<script>
export default {
    props: {
        data: {
            type: Array,
        },
        seeActions: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            fields,
        }
    },
    computed: {
        checkpoints() {
            return this.data.sort((a, b) => a.created_at - b.created_at)
        },
    },
    methods: {
        removeNovelty(id) {
            this.$emit('remove-novelty', id)
        },
    },
}

const fields = [
    {
        key: 'index',
        label: 'ID',
    },
    {
        key: 'novelty',
        label: 'Novedad',
    },
    {
        key: 'created_at',
        label: 'Fecha',
    },
    {
        key: 'actions',
        label: 'Accion',
    },
]
</script>